<div class="insurance-subscription-item "
     [class.with-details]="showDetails">

  <header (click)="onHeaderClick()">

    <div class="logo">
      <llc-insurance-partner [ref]="insuranceProvider$ | async"
                             [showLogo]="true"
                             [useFallbackLogo]="true"
      ></llc-insurance-partner>
    </div>

    <div class="content">

      <div class="main-row">
        <div class="category">
          {{ categoryname$ | async }}
        </div>
        <div *ngIf="(insuredInfo$ | async) || (insuredContactName$ | async)"
             class="subject"
             title="Sujet assuré" i18n-title>
          <ng-template [ngIf]="insuredContactName$ | async" [ngIfElse]="noInsuredContact">
            {{ insuredContactName$ | async }}
          </ng-template>
          <ng-template #noInsuredContact>
            {{ insuredInfo$ | async }}
          </ng-template>
        </div>
        <div class="separator"></div>
        <div class="ref">#{{internalReference$ | async}}</div>
      </div>

      <div class="subrow" *ngIf="showSubTitle">
        <div class="provider-name">
          {{ providerName$ | async }}
        </div>
        <div class="provider-product-name" *ngIf="providerName$ | async">
          <!--          <span> {{ providerProductName$ | async }} </span>-->
          <span> {{ providerReference$ | async }} </span>
        </div>
        <span class="separator"></span>

        <div class="status">
          <cf-insurance-subscription-status [status]="status$ | async"
          ></cf-insurance-subscription-status>
        </div>
      </div>
    </div>

  </header>


  <div class="details" [@detailsCollapsed]="showDetails ? 'false' : 'true'">

    <div class="details-bloc info-bloc" *ngIf="showDetailsInfo">
      <header>
        Informations
      </header>

      <div class="row" *ngIf="(pricing$ | async) > 0">
        <label>Prime</label>
        <span>
          {{ pricing$ | async | cCurrency }}
        </span>
      </div>
      <div class="row" *ngIf="(recurrenceLabel$ | async)?.length > 0">
        <label>Récurrence</label>
        <span> {{ recurrenceLabel$ | async }} </span>
      </div>
      <div class="row" *ngIf="birthdayDate$ | async">
        <label>Prochain anniv.</label>
        <span> {{ birthdayDate$ | async | date:'mediumDate' }} </span>
      </div>

      <div class="empty-bloc"
           *ngIf="!((pricing$ | async) > 0) && !((recurrenceLabel$ | async)?.length > 0) && (birthdayDate$ | async) == null">
        <label>Aucune donnée</label>
      </div>
    </div>


    <div class="details-bloc info-bloc" *ngIf="showDetailsReserves">
      <header>
        Réserves
      </header>

      <div class="row" *ngIf="lifeInsuranceReserveImportDate$ | async">
        <label>Dernier import</label>
        <span> {{ lifeInsuranceReserveImportDate$ | async  | date:'mediumDate'}} </span>
      </div>
      <div class="row" *ngIf="lifeInsuranceReserveAmount$ | async">
        <label>Réserves</label>
        <span> {{ lifeInsuranceReserveAmount$ | async  | cCurrency }} </span>
      </div>
      <div class="row" *ngIf="lifeInsuranceRetirementAmount$ | async">
        <label>Montant estimé à l'échéance</label>
        <span> {{ lifeInsuranceRetirementAmount$ | async  | cCurrency }} </span>
      </div>
      <div class="row" *ngIf="incomesGuaranteeCoveredAmount$ | async">
        <label>Couverture revenus garantis</label>
        <span> {{ incomesGuaranteeCoveredAmount$ | async | cCurrency   }} </span>
      </div>
      <div class="row" *ngIf="deathInsuranceCoveredAmount$ | async">
        <label>Couverture décès</label>
        <span> {{ deathInsuranceCoveredAmount$ | async | cCurrency:'allowStrings'  }} </span>
      </div>

      <div class="empty-bloc"
           *ngIf="(lifeInsuranceReserveImportDate$ | async) == null && (lifeInsuranceReserveAmount$ | async) == null && (lifeInsuranceRetirementAmount$ | async) == null && (incomesGuaranteeCoveredAmount$ | async) == null && ( deathInsuranceCoveredAmount$ | async ) == null">
        <label>Aucune donnée</label>
      </div>
    </div>

    <div class="details-bloc linked-subscriptions" *ngIf="(linkedSubscription$ | async)?.length > 0">
      <header [class.empty]="(linkedSubscription$ | async)?.length === 0">
        { (linkedSubscription$ | async)?.length, plural,
          =0 { Aucune autre police liée }
          =1 { Une autre police liée }
          other { {{ (linkedSubscription$ | async)?.length }} autres polices liées }
          }
      </header>
      <div class="linked-details" *ngIf="showLinked && childrenVisible">
        <div *ngFor="let linked of linkedSubscription$ | async"
             class="linked-contract-details">
          <cf-insurance-subscription-item [insuranceSubscription]="linked"
                                          [showLinked]="false"
                                          [showFooter]="false"
                                          [showDetails]="false"
          ></cf-insurance-subscription-item>
        </div>
      </div>
    </div>


    <div class="details-bloc documents-bloc" *ngIf="showDetails && documentsVisible">
      <header *ngIf="documentsCount > 0">
        { documentsCount, plural,
          =1 {1 document}
          other { {{documentsCount}} documents }
          }
      </header>
      <cf-subscription-document-list [pageSize]="5"
                                     [rowClickable]="true"
                                     [subscriptionRef]="(insuranceSubscriptionSource$ | async).subscriptionRef"
                                     (rowClick)="onDownloadFileClick($event)"
                                     (totalCountChange)="documentsCount = $event"
      ></cf-subscription-document-list>
    </div>

  </div>

  <footer *ngIf="showFooter">

    <div class="row">

      <a *ngIf="signLink$ | async"
         class="active"
         [href]="signLink$ | async"
         title="Signer les documents">
        <i class="fa fa-certificate"></i>
        <span class="label">Signer les documents</span>
      </a>

      <span class="separator"></span>
      <div class="update-date" hidden>
        Mise à jour: {{ updateDate$ | async | cDate }}
      </div>
    </div>

    <div class="row details-bar"
         (click)="onHeaderClick()">
      <a *ngIf="!showDetails">
        Plus de détails
      </a>
    </div>

  </footer>


</div>

<file-download></file-download>
